import Vue from 'vue';
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
import ToolBar from "../../parts/ToolBar.vue";
import MessageDialog from '../../parts/MessageDialog.vue';
export default Vue.extend({
    components: { ToolBar, MessageDialog },
    name: "WalletCreationEnd",
    data() {
        return {
            showCaution1: false,
            showCaution2: false,
        };
    },
    methods: {
        goSecurityLesson() {
            this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_LESSON, '/wallet/select');
            this.$router.push('/lesson/introduction');
        },
        goHome() {
            this.showCaution1 = true;
        },
        onOkCaution1() {
            this.showCaution2 = true;
        },
        onOkCaution2() {
            this.$router.push('/top?tab=home');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/wallet/WalletCreationEnd.vue
// module id = 628
// module chunks = 1